import clientSchema from './clientSchema.graphql';

export { clientSchema };
